import { Box, Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const PMSNavButtons = ({
  handleClickPrev,
  handleClickNext,
  handleSaveAndExit,
  fwdLabel = "Next step",
  bkwdLabel = "Previous",
}) => {
  const pmsStep = useSelector((state) => state.layout.pmsSearchStep);

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        {Number(pmsStep) > 0 && (
          <Button
            display={{ base: "none", lg: "flex" }}
            variant="gradient"
            fromcolor="primary.600"
            tocolor="primary.500"
            onClick={() => handleClickPrev()}
          >
            {bkwdLabel}
          </Button>
        )}
      </Box>
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <Button
          display={{ base: "none", lg: "flex" }}
          onClick={() => handleClickNext()}
        >
          {fwdLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default PMSNavButtons;
